import { Col, Row, Container } from "reactstrap";
import { useTranslation } from "react-i18next";

export const CallForAbstractsContent = () => {
  const { t } = useTranslation();

  const topics = [
    { icon: "🧬", title: t("cfa_topic_1") },
    { icon: "🚀", title: t("cfa_topic_2") },
    { icon: "🛰️", title: t("cfa_topic_3") },
    { icon: "📋", title: t("cfa_topic_4") },
    { icon: "📚", title: t("cfa_topic_5") },
    { icon: "🌍", title: t("cfa_topic_6") },
    { icon: "💡", title: t("cfa_topic_7") },
    { icon: "🤖", title: t("cfa_topic_8") },
    { icon: "📡", title: t("cfa_topic_9") },
  ];

  const dates = [
    { icon: "📝", activity: t("cfa_table_abstracts"), date: t("cfa_table_abstracts_date") },
    { icon: "✅", activity: t("cfa_table_notification"), date: t("cfa_table_notification_date") },
    { icon: "🎟️", activity: t("cfa_table_registration"), date: t("cfa_table_registration_date") },
    { icon: "📊", activity: t("cfa_table_presentations"), date: t("cfa_table_presentations_date") },
    { icon: "📄", activity: t("cfa_table_manuscript"), date: t("cfa_table_manuscript_date") },
  ];

  return (
    <div style={{ paddingTop: '60px', paddingBottom: '60px', backgroundColor: '#f8f9fa' }}>
      <Container>

        {/* Título */}
        <Row className="mb-5">
          <Col>
            <h1 className="text-center" style={{ color: '#333333', fontWeight: 'bold', marginBottom: '1rem' }}>
              {t("cfa_title")}
            </h1>
            <p className="text-center lead" style={{ color: '#666666' }}>
              {t("cfa_lead")}
            </p>
          </Col>
        </Row>

        {/* Pasos a seguir */}
        <Row className="mb-5">
          <Col>
            <div className="d-flex justify-content-center align-items-start flex-wrap gap-2">
              {[
                { icon: "📝", label: t("cfa_step_1") },
                { icon: "📤", label: t("cfa_step_2") },
                { icon: "✅", label: t("cfa_step_3") },
                { icon: "🎟️", label: t("cfa_step_4") },
              ].map((step, idx, arr) => (
                <div key={idx} className="d-flex align-items-start">
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    width: "140px",
                  }}>
                    <div style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.5rem",
                      boxShadow: "0 4px 15px rgba(17, 153, 142, 0.3)",
                      marginBottom: "0.5rem",
                      color: "white",
                      fontWeight: "bold",
                      flexShrink: 0,
                    }}>
                      {step.icon}
                    </div>
                    <span style={{ color: "#555", fontWeight: "600", fontSize: "0.85rem" }}>
                      {step.label}
                    </span>
                  </div>
                  {idx < arr.length - 1 && (
                    <span style={{ fontSize: "1.5rem", color: "#11998e", margin: "0 0.5rem", marginTop: "15px" }}>→</span>
                  )}
                </div>
              ))}
            </div>
          </Col>
        </Row>

        {/* Introducción */}
        <Row className="mb-5">
          <Col>
            <div className="cfa-card" style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '15px',
              padding: '2.5rem',
              boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
              color: 'white'
            }}>
              <p style={{ marginBottom: '1rem' }}>{t("cfa_intro")}</p>
              <p style={{ marginBottom: 0 }}>{t("cfa_about_cec")}</p>
            </div>
          </Col>
        </Row>

        {/* Temas de interés */}
        <Row className="mb-5">
          <Col>
            <h2 className="text-center mb-3" style={{ color: '#333333', fontWeight: '600' }}>
              {t("cfa_topics_title")}
            </h2>
            <p className="text-center mb-4" style={{ color: '#555', fontSize: '1.1rem' }}>
              {t("cfa_topics_intro")}
            </p>
            <Row>
              {topics.map((topic, idx) => (
                <Col md="4" sm="6" key={idx} className="mb-3">
                  <div style={{
                    background: 'white',
                    borderRadius: '10px',
                    padding: '1.2rem',
                    textAlign: 'center',
                    boxShadow: '0 3px 10px rgba(0,0,0,0.06)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'default',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.8rem'
                  }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.12)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.06)';
                    }}
                  >
                    <span style={{ fontSize: '1.5rem' }}>{topic.icon}</span>
                    <span style={{ fontWeight: '500', color: '#333', fontSize: '0.95rem' }}>{topic.title}</span>
                  </div>
                </Col>
              ))}
            </Row>
            <p className="text-center mt-4" style={{ color: '#555', lineHeight: '1.8' }}>
              {t("cfa_audience")}{" "}
              <strong>{t("cfa_in_person")}</strong>
            </p>
          </Col>
        </Row>

        {/* Requisitos y Formato */}
        <Row className="mb-5">
          <Col lg="6" className="mb-4">
            <div className="cfa-card" style={{
              background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
              borderRadius: '15px',
              padding: '2rem',
              boxShadow: '0 10px 30px rgba(17, 153, 142, 0.3)',
              height: '100%',
              color: 'white'
            }}>
              <h3 style={{ fontWeight: 'bold', marginBottom: '1.2rem', color: 'white' }}>
                {t("cfa_requirements_title")}
              </h3>
              <p>{t("cfa_requirements_intro")}</p>
              <ol style={{ paddingLeft: '1.2rem' }}>
                <li>{t("cfa_req_1")}</li>
                <li>{t("cfa_req_2")}</li>
                <li>{t("cfa_req_3")}</li>
                <li>{t("cfa_req_4")}</li>
                <li>{t("cfa_req_5")}</li>
              </ol>
            </div>
          </Col>
          <Col lg="6" className="mb-4">
            <div className="cfa-card" style={{
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              borderRadius: '15px',
              padding: '2rem',
              boxShadow: '0 10px 30px rgba(245, 87, 108, 0.3)',
              height: '100%',
              color: 'white'
            }}>
              <h3 style={{ fontWeight: 'bold', marginBottom: '1.2rem', color: 'white' }}>
                {t("cfa_format_title")}
              </h3>
              <p>{t("cfa_format_text")}</p>
              <h3 style={{ fontWeight: 'bold', marginBottom: '1.2rem', marginTop: '1.5rem', color: 'white' }}>
                {t("cfa_manuscript_title")}
              </h3>
              <p style={{ marginBottom: 0 }}>{t("cfa_manuscript_text")}</p>
            </div>
          </Col>
        </Row>

        {/* Fechas importantes */}
        <Row className="mb-5">
          <Col>
            <h2 className="text-center mb-4" style={{ color: '#333333', fontWeight: '600' }}>
              {t("cfa_important_dates_title")}
            </h2>
            <Row className="justify-content-center">
              {dates.map((item, idx) => (
                <Col md="10" lg="8" key={idx}>
                  <div style={{
                    background: 'white',
                    borderRadius: '10px',
                    padding: '1.2rem 1.5rem',
                    marginBottom: '0.8rem',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '1rem'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                      <span style={{ fontSize: '1.5rem' }}>{item.icon}</span>
                      <span style={{ fontWeight: '500', color: '#333' }}>{item.activity}</span>
                    </div>
                    <span style={{ fontWeight: '600', color: '#764ba2', whiteSpace: 'nowrap', fontSize: '0.95rem' }}>
                      {item.date}
                    </span>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>

        {/* Notas importantes */}
        <Row className="mb-5">
          <Col md={{ size: 10, offset: 1 }} lg={{ size: 8, offset: 2 }}>
            <div className="cfa-card" style={{
              background: 'linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)',
              borderRadius: '15px',
              padding: '2rem',
              boxShadow: '0 10px 30px rgba(252, 74, 26, 0.25)',
              color: 'white'
            }}>
              <h4 style={{ fontWeight: 'bold', marginBottom: '1rem', color: 'white' }}>
                ⚠️ {t("cfa_notes_title")}
              </h4>
              <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>{t("cfa_note_registration")}</li>
                <li><strong>{t("cfa_no_refunds")}</strong></li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* Contacto */}
        <Row className="mb-5">
          <Col className="text-center">
            <p style={{ color: '#555', fontSize: '1.05rem' }}>
              {t("cfa_more_info")}{" "}
              <a href="https://cecspace.org" style={{ color: '#667eea', fontWeight: '500' }}>cecspace.org</a>
              {" · "}
              {t("cfa_questions")}{" "}
              <a href="mailto:faq@cecspace.org" style={{ color: '#667eea', fontWeight: '500' }}>faq@cecspace.org</a>
            </p>
          </Col>
        </Row>

        {/* CTA */}
        <Row className="mt-3">
          <Col>
            <div className="text-center p-5" style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '15px',
              color: 'white',
              boxShadow: '0 15px 35px rgba(0,0,0,0.15)'
            }}>
              <h3 className="mb-3" style={{ fontWeight: 'bold', color: '#ffffff' }}>
                {t("cfa_cta_title")} 🚀
              </h3>
              <p className="lead mb-4" style={{ color: '#ffffff' }}>
                {t("cfa_cta_text")}
              </p>
              <a
                href="https://easychair.org/conferences/?conf=cec2026"
                className="btn btn-light btn-lg px-5"
                target="_blank"
                rel="noreferrer"
                style={{
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  color: '#764ba2',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                }}
              >
                {t("cfa_cta_button")}
              </a>
            </div>
          </Col>
        </Row>

      </Container>

      <style>{`
        .cfa-card p,
        .cfa-card li {
          text-align: justify !important;
          font-size: 1rem !important;
          line-height: 1.8 !important;
        }
      `}</style>
    </div>
  );
};